import { Pipe, PipeTransform } from '@angular/core';
import * as debug from 'debug';
import * as _ from 'lodash';

@Pipe({
  name: 'getDefaultPlaceImage',
})
export class GetDefaultPlaceImagePipe implements PipeTransform {
  log = debug('app:GetDefaultPlaceImagePipe');

  transform(place: string, ...args) {
    if (_.get(place, 'placeId')) {
      if (_.get(place, 'placeId') === 'SAPP_BROS') {
        return (
          'assets/imgs/location_card_fallback/' +
          _.get(place, 'placeId') +
          '.jpg'
        );
      } else {
        return (
          'assets/imgs/location_card_fallback/' +
          _.get(place, 'placeId') +
          '.svg'
        );
      }
    } else if (_.get(place, 'nearbyPlace')) {
      if (_.get(place, 'googlePlaceType') === 'restaurants') {
        return 'assets/imgs/restaurants_image_placeholder.svg';
      } else if (_.get(place, 'googlePlaceType') === 'lodging') {
        return 'assets/imgs/lodging_image_placeholder.svg';
      }
    } else {
      return 'assets/imgs/Image_placeholder2px.png';
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/get-default-place-image/get-default-place-image.ts